import { Config } from '@client/hoc/config/configShape';

export const getSupportedLanguages = (config: Config) => {
    const appdomains = config.getSwitchUrlAppdomains();
    if (!appdomains) {
        return null;
    }

    const {
        pathname = '',
        search = '',
        hash = '',
    } = (typeof window === 'undefined' ? {} : window.location);

    return Object.keys(appdomains).map(appdomainId => ({
        countryCode: config.getCountryCodeForAppdomainId(appdomainId).toUpperCase(),
        url: `//${appdomains[appdomainId]}${pathname}${search}${hash}`,
        active: String(config.appdomain) === appdomainId,
    }));
}
